<template>
  <div class="grid-container">
    <a href="https://www.youtube.com/DreamingSpanish"><div class="logo"><img alt="Logo" src="../assets/logo.png"></div></a>
    <div class="title">Text Simplifier</div>
    <a href="https://www.youtube.com/DreamingSpanish"><div class="mobilelogo"><img id="logo" alt="Logo" src="../assets/logo.png"></div></a>
<!--     <div class="selectlanguage">
      <div class="selectwrapper">
        <select>
          <option value="volvo">Spanish</option>
        </select>
      </div>
    </div> -->
    <div class="icons">
      <!-- <img alt="Open file" src="../assets/open-file.png">
      <img alt="Create a new file" src="../assets/add-file.png">
      <img alt="Undo" src="../assets/undo.png"> -->
      <a v-on:click.prevent="download($event)" title="Download file"><img alt="Download file" src="../assets/save-to-disk.png"></a>
      <a v-on:click.prevent="statistics($event)" title="Download statistics"><img alt="Download statistics" src="../assets/statistics.png"></a>
    </div>
    <div class="filename"><!-- <span>My Simple Spanish Text 1<img alt="Edit filename" src="../assets/pencil.png"> --></span></div>
    <div class="selectlevel">
      <div class="selectwrapper">
        <select v-model="range">
          <option v-for="(item, index) in ranges" v-bind:value="item" v-bind:key="index">
            {{ item }}
          </option>
        </select>
      </div>
    </div>
    <pre class="editor"
      ref="pre"
      v-html="content"
      contenteditable="true"
      @keydown="handleKeyDown"
      @keyup="handleKeyUp"
      @click="handleClick"
      ></pre>
    <div class="info">{{ wordCount }} words - {{ charCount }} chars - <span v-bind:class="{ veryhard: percentKnown < 95, hard: percentKnown < 98 }">{{ percentKnown }}% of known words</span></div>
    <div class="contact"><a href="mailto:pablo@dreamingspanish.com">Contact</a></div>
  </div>
</template>

<script>
import escapeHtml from "escape-html"
import axios from "axios"
import { saveAs } from 'file-saver';
import selectionRange from "../utils/selection.js";
import unpronoun from "../utils/unpronoun.js";
import htmlToPlain from "../utils/htmlToPlain.js";

const REGEX = /([A-Za-zÁáÉéÍíÓóÚúÜüÑñ]+|[^A-Za-zÁáÉéÍíÓóÚúÜüÑñ]+|[\n\r]+)/g
const REGEX_WORD = /[a-záéíóúüñ]+/

export default {
  model: {
    prop: "code",
    event: "change"
  },
  props: {
    emitEvents: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      undoStack: [],
      selection: undefined,
      undoOffset: 0,
      undoTimestamp: 0,
      lastPos: 0,
      codeData: "",
      composing: false,
      dictionary: {},
      freqList: {},
      ranges: [],
      range: 0,
      wordCount: 0,
      charCount: 0,
      easyWords: 0,
      hardWords: 0
    }
  },
  watch: {
    code: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.codeData = ""
        } else {
          this.codeData = newVal
        }
      }
    },
    range: function () {
      const plain = this.getPlain()
      this.updateContent(plain)
    }
  },
  computed: {
    content() {
      let result = this.colorize(this.codeData)
      return result
    },
    percentKnown() {
      if (this.easyWords + this.hardWords == 0) return 0

      return Number(this.easyWords / (this.easyWords + this.hardWords) * 100).toFixed(1)
    }
  },
  updated() {
    if (this.selection) {
      selectionRange(this.$refs.pre, this.selection)
    }
  },
  mounted() {
    this.recordChange(this.getPlain())
    this.undoTimestamp = 0 // Reset timestamp

    const onPaste = e => {
      e.preventDefault()
      const currentCursorPos = selectionRange(this.$refs.pre)

      // get text representation of clipboard
      var text = (e.originalEvent || e).clipboardData.getData("Text")
      // insert text manually
      document.execCommand("insertHTML", false, escapeHtml(text))

      const newCursorPos = currentCursorPos.end + text.length
      this.selection = { start: newCursorPos, end: newCursorPos }

      const plain = this.getPlain()
      this.recordChange(plain, this.selection)
      this.updateContent(plain)
    }
    const $pre = this.$refs.pre
    $pre.addEventListener("paste", onPaste)
    this.$once("hook:beforeDestroy", () => {
      $pre.removeEventListener("paste", onPaste)
    })
    $pre.addEventListener("compositionstart", () => {
      this.composing = true
    })
    $pre.addEventListener("compositionend", () => {
      // for canceling input.
      this.composing = false
    })

    axios
      .get('/reference.json')
      .then(response => {
        let words = response.data
        let dict = {}

        for (let i = 0; i < words.length; i++) {
          dict[words[i][0]] = words[i][1]
        }

        this.dictionary = dict
      })
      .catch(error => console.error(error))

    axios
      .get('/corpus.json')
      .then(response => {
        let ranges = response.data
        let freqList = {}
        for (let i = 0; i < ranges.length; i++) {
          let rangenumber = ranges[i].range
          this.ranges.push(rangenumber)
          for (let j = 0; j < ranges[i].words.length; j++) {
            freqList[ranges[i].words[j]] = rangenumber
          }
        }

        this.range = this.ranges[0]
        this.freqList = freqList
      })
      .catch(error => console.error(error))
  },

  methods: {
    handleClick(evt) {
      if (this.emitEvents) {
        this.$emit("editorClick", evt)
      }
      this.undoTimestamp = 0 // Reset timestamp
      this.selection = selectionRange(this.$refs.pre)
    },
    getPlain() {
      if (this._innerHTML === this.$refs.pre.innerHTML) {
        return this._plain
      }
      const plain = htmlToPlain(this.$refs.pre.innerHTML)
      this._innerHTML = this.$refs.pre.innerHTML
      this._plain = plain

      return this._plain
    },
    recordChange(plain, selection) {
      if (plain === this.undoStack[this.undoStack.length - 1]) {
        return
      }

      if (this.undoOffset > 0) {
        this.undoStack = this.undoStack.slice(0, -this.undoOffset)
        this.undoOffset = 0
      }

      const timestamp = Date.now()
      const record = { plain, selection }

      // Overwrite last record if threshold is not crossed
      if (timestamp - this.undoTimestamp < 3000) {
        this.undoStack[this.undoStack.length - 1] = record
      } else {
        this.undoStack.push(record)

        if (this.undoStack.length > 50) {
          this.undoStack.shift()
        }
      }

      this.undoTimestamp = timestamp
    },
    updateContent(plain) {
      this.$emit("change", plain)
    },
    restoreStackState(offset) {
      const { plain, selection } = this.undoStack[
        this.undoStack.length - 1 - offset
      ]

      this.selection = selection
      this.undoOffset = offset
      this.updateContent(plain)
    },
    undo() {
      const offset = this.undoOffset + 1
      if (offset >= this.undoStack.length) {
        return
      }

      this.restoreStackState(offset)
    },
    redo() {
      const offset = this.undoOffset - 1
      if (offset < 0) {
        return
      }

      this.restoreStackState(offset)
    },
    handleKeyDown(evt) {
      if (this.emitEvents) {
        this.$emit("keydown", evt)
      }

      if (evt.keyCode === 9) {
        document.execCommand("insertHTML", false, "\t")
        evt.preventDefault()
      } else if (evt.keyCode === 8) {
        // Backspace Key
        const { start: cursorPos, end: cursorEndPos } = selectionRange(
          this.$refs.pre
        )
        if (cursorPos !== cursorEndPos) {
          return; // Bail on selections
        }

        // Delete char
        document.execCommand("delete", false)

        evt.preventDefault()
      } else if (evt.keyCode === 13) {
        // Enter Key

        // https://stackoverflow.com/questions/35585421
        // add a space and remove it. it works :/
        document.execCommand("insertHTML", false, "\n ")
        document.execCommand("delete", false)

        evt.preventDefault()
      } else if (
        // Undo / Redo
        evt.keyCode === 90 &&
        evt.metaKey !== evt.ctrlKey &&
        !evt.altKey
      ) {
        if (evt.shiftKey) {
          this.redo()
        } else {
          this.undo()
        }

        evt.preventDefault()
      }
    },
    handleKeyUp(evt) {
      const keyupCode = evt.which
      if (this.composing) {
        if (keyupCode === 13) {
          // finish inputting via IM.
          this.composing = false
        } else {
          // now inputting words using IM.
          // must not update view.
          return
        }
      }

      if (this.emitEvents) {
        this.$emit("keyup", evt)
      }
      if (
        evt.keyCode === 91 || // left cmd
        evt.keyCode === 93 || // right cmd
        evt.ctrlKey ||
        evt.metaKey
      ) {
        return
      }

      // Enter key
      if (evt.keyCode === 13) {
        this.undoTimestamp = 0
      }

      this.selection = selectionRange(this.$refs.pre)

      if (
        evt.keyCode !== 37 && // left
        evt.keyCode !== 38 && // up
        evt.keyCode !== 39 && // right
        evt.keyCode !== 40 // down
      ) {
        const plain = this.getPlain()

        this.recordChange(plain, this.selection)
        this.updateContent(plain)
      } else {
        this.undoTimestamp = 0
      }
    },
    colorize(input) {
      let result = ''
      let wordCount = 0
      let easyWords = 0
      let hardWords = 0
      let match

      // eslint-disable-next-line
      while (match = REGEX.exec(input)) {
        let word = match[0]
        let lowerCaseWord = word.toLowerCase()

        if (lowerCaseWord.match(REGEX_WORD)) {
          wordCount++
          let lemma = this.dictionary[lowerCaseWord]
          if (!lemma) {
            let unpronouned = unpronoun(lowerCaseWord)
            if (unpronouned) {
              lemma = this.dictionary[unpronouned]
            }
          }
          if (!lemma) {
            result += '<span class="uw">' + word + '</span>'
            continue
          }
          let freq = this.freqList[lemma]
          if (!freq || freq > this.range) {
            hardWords++
            result += '<span class="hw">' + word + '</span>'
          } else {
            easyWords++
            result += word
          }
        } else {
          result += word
        }
      }

      this.wordCount = wordCount
      this.charCount = input.length
      this.easyWords = easyWords
      this.hardWords = hardWords

      return result
    },
    download() {
      let text = this.getPlain()
      let blob = new Blob([text], {type: "text/plain;charset=utf-8"})
      saveAs(blob, "My Simple Spanish Text 1.txt")
    },
    statistics() {
      let text = ''
      text += `Word count: ${this.wordCount}\n`
      text += `Character count: ${this.charCount}\n`
      text += `Number of easy words: ${this.easyWords}\n`
      text += `Number of hard words: ${this.hardWords}\n`
      text += `Number of unclassified words (proper nouns, etc.): ${this.wordCount - this.easyWords - this.hardWords}\n`
      text += '\n'
      text += '## Glossary ##\n'
      text += '\n'

      let input = this.codeData

      let words = {}

      let match

      // eslint-disable-next-line
      while (match = REGEX.exec(input)) {
        let word = match[0]
        let lowerCaseWord = word.toLowerCase()

        if (lowerCaseWord.match(REGEX_WORD)) {
          let lemma = this.dictionary[lowerCaseWord]
          if (!lemma) {
            let unpronouned = unpronoun(lowerCaseWord)
            if (unpronouned) {
              lemma = this.dictionary[unpronouned]
            }
          }
          if (!lemma) {
            lemma = word
          }

          if (!words[lemma]) {
            words[lemma] = 1
          } else {
            words[lemma]++
          }
        }
      }

      let keys = Object.keys(words).sort()

      for (let i = 0; i < keys.length; i++) {
        text += `${keys[i]} ${words[keys[i]]}\n`
      }

      let blob = new Blob([text], {type: 'text/plain;charset=utf-8'})
      saveAs(blob, 'Statistics and glossary.txt')
    }
  }
}

</script>

<style>
.prism-editor-wrapper code {
  font-family: inherit;
  line-height: inherit;
}
.prism-editor-wrapper {
  /* position: absolute; */
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  overflow: auto;
  tab-size: 1.5em;
  -moz-tab-size: 1.5em;
}

.prism-editor__code {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  flex-grow: 2;
  min-height: 100%;
  box-sizing: border-box;
  /* padding: 4px 2px 4px 8px; */
  tab-size: 4;
  -moz-tab-size: 4;
  outline: none;
}
pre.prism-editor__code:focus {
  outline: none;
}
</style>
